import * as React from 'react';
import ReactSelect, {
	DropdownIndicatorProps,
	MultiValue,
	SingleValue,
	components,
} from 'react-select';
import { useFiltersContext } from '../../contexts/filters';
import { useSettingsContext } from '../../contexts/settings';

interface ISelectOption {
	label: string;
	value: string;
}

const PostTypePills = () => {
	const { selectedPostType, selectPostType } = useFiltersContext();
	const { postTypeOptions } = useSettingsContext();
	const options = postTypeOptions as ISelectOption[];

	const [value, setValue] = React.useState<ISelectOption | undefined>(
		() => options.find((o) => o.value === (selectedPostType ?? '')) ?? options[0]
	);
	const prevValue = React.useRef<string>(
		(options.find((o) => o.value === (selectedPostType ?? '')) ?? options[0])?.value ?? ''
	);

	React.useEffect(() => {
		if (!options.length) return;
		const next = options.find((o) => o.value === (selectedPostType ?? '')) ?? options[0];
		if (next.value !== prevValue.current) {
			setValue(next);
			prevValue.current = next.value;
		}
	}, [selectedPostType, options]);

	const handleOnChange = (newValue: SingleValue<ISelectOption> | MultiValue<ISelectOption>) => {
		const option = newValue as SingleValue<ISelectOption>;
		if (option && prevValue.current !== option.value && selectPostType) {
			setValue(option);
			selectPostType(option.value);

			if (window.dataLayer) {
				window.dataLayer.push({
					event: 'post_filter',
					filter: 'post_type',
					filter_selection: option.label, // eslint-disable-line camelcase
				});
			}

			prevValue.current = option.value;
		}
	};

	const DropdownIndicator = (props: DropdownIndicatorProps<ISelectOption>) => {
		return (
			<components.DropdownIndicator {...props}>
				<svg
					width="20"
					height="20"
					viewBox="0 0 24 24"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M12.0001 14.95L3.81862 6.63867L2.39331 8.04171L12.0001 17.801L21.6068 8.04171L20.1815 6.63867L12.0001 14.95Z"
					/>
				</svg>
			</components.DropdownIndicator>
		);
	};

	return !options.length ? null : (
		<>
			<ReactSelect
				className="pfa-filter-select pfa-filter-select--mobile"
				classNamePrefix="pfa-filter-select"
				options={options}
				components={{ DropdownIndicator }}
				onChange={handleOnChange}
				value={value}
				isClearable={false}
				isSearchable={false}
				isMulti={false}
			/>
			<div className="pfa-filter-large-pills pfa-filter-large-pills--desktop">
				{options.map((option) => (
					<label
						key={option.value}
						className="pfa-filter-large-pills__label btn"
						htmlFor={`pfa-filter-large-pills-post-type-${option.value || 'all'}`}
					>
						<input
							type="checkbox"
							id={`pfa-filter-large-pills-post-type-${option.value || 'all'}`}
							value={option.value}
							className="pfa-filter-large-pills__input"
							checked={value?.value === option.value}
							onChange={() => handleOnChange(option)}
						/>
						{option.label}
					</label>
				))}
			</div>
		</>
	);
};

PostTypePills.displayName = 'PostTypePills';

export default PostTypePills;
